module.exports = __webpack_public_path__ + "static/media/contactIntro.691639a4.mp4";